import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button
} from '@material-ui/core';
import { Plus as PlusIcon, RefreshCw as RefreshIcon } from 'react-feather';
import { useNavigate } from 'react-router-dom';

const LinksListToolbar = ({ onRefresh, ...rest }) => {
  const navigate = useNavigate();

  return (
    <Box {...rest}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          mb: 2
        }}
      >
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => navigate('/app/link')}
            startIcon={<PlusIcon />}
          >
            Gerar Novo Link
          </Button>
          <Button
            color="secondary"
            variant="outlined"
            onClick={onRefresh}
            startIcon={<RefreshIcon />}
          >
            Atualizar
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

LinksListToolbar.propTypes = {
  onRefresh: PropTypes.func
};

export default LinksListToolbar;
